import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "form-buttons-w text-center" }

import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import {computed, onMounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute, useRouter} from 'vue-router';
import useVuelidate from '@vuelidate/core';
import BaseInput from "@/components/base/BaseInput.vue";
import {requiredRule} from "@/shared/validators/validationRules";
import SaveButton from "@/components/button/SaveButton.vue";
import unemployedPrivateCoachingService from "@/api/Unemployed/PrivateCoaching";


export default /*@__PURE__*/_defineComponent({
  __name: 'Form',
  props: {
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
  documentGroupUuid: {
    type: String,
    required: false,
    default: '',
  },
  selectedGroupTitle: {
    type: String,
    required: false,
    default: '',
  },
},
  emits: ['update:modelValue', 'update:submitForm'],
  setup(__props, { emit: __emit }) {

const {t} = useI18n();
const route = useRoute();
const unemployedId = +(route.params.unemployedId || route.params.id);
const emit = __emit;
const isSubmitting = ref(false);
const isLoaded = ref(false);

const props = __props;

const formData = ref<any>({
  groupTitle: "",
});

watch(
    () => props.selectedGroupTitle,
    (title) => {
      if (title) {
        formData.value.groupTitle = title;
      }
    },
    { immediate: true }
);

const rules = computed(() => {
  return {
    groupTitle: requiredRule(t),
  };
});

const computedRules = computed(() => rules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitFormData() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.unemployedId = unemployedId;

    if (props.documentGroupUuid) {
      await unemployedPrivateCoachingService.editDigitalDocuments(formData.value, props.documentGroupUuid);
    } else {
      await unemployedPrivateCoachingService.postDigitalDocuments(formData.value);
    }

    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

onMounted(async () => {
  CloseToast()
  isLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(submitFormData, ["prevent"]),
    novalidate: ""
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(BaseInput, {
          modelValue: formData.value.groupTitle,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.groupTitle) = $event)),
          label: "Titel des Dokuments",
          required: true,
          validation: _unref(v$).groupTitle,
          messages: _unref(v$).groupTitle.required.$message
        }, null, 8, ["modelValue", "validation", "messages"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(SaveButton, {
        label: _ctx.$t('general.button.save'),
        loading: isSubmitting.value
      }, null, 8, ["label", "loading"])
    ])
  ], 32))
}
}

})